import type { SVGProps } from 'react';

export const Burger = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <g id="burger">
        <path
          d="M3 12H21M3 6H21M3 18H21"
          id="Vector"
          stroke="var(--stroke-0, #FAFAFA)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};
